import React from "react";
import DashboardSideBar from "../../components/Shop/Layout/DashboardSideBar";
import DashboardHero from "../../components/Shop/DashboardHero";

const ShopDashboardPage = () => {
  return (
    <div className="min-h-screen bg-secondary-50">
      {/* Sidebar handles its own header/mobile bar */}
      <DashboardSideBar active={1} />

      {/* Main Content */}
      <div className="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
        <DashboardHero />
      </div>
    </div>
  );
};

export default ShopDashboardPage;
